/* src/layouts/insight-hub/components/toolbar/index.js */

import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import MDBox from "components/MDBox";
import ADDateRange from "components/ADDateRange";
import ToolSelector from "./ToolSelector";
import PredictionToggle from "./PredictionToggle";
import ChartCategorySelector from "./ChartCategorySelector";
import { charts } from "layouts/insight-hub";

function Toolbar({
  onDateChange,
  onTogglePrediction,
  isPredictionEnabled,
  selectedCategories,
  setSelectedCategories,
  selectedProfiles,
  dateRange,
  contentChartRef,
  onAddProfile,
  entitlements,
  validationAttempt,
  chartViewModes,
  onScheduleReport // [NEW]
}) {
  const [isTransparent, setIsTransparent] = useState(true);
  const [navHeight, setNavHeight] = useState(75);

  const activeChartIds = charts
    .filter(chart => selectedCategories.includes(chart.category))
    .map(chart => chart.id);

  useEffect(() => {
    const navbarEl = document.querySelector("header.MuiAppBar-root");
    if (navbarEl) setNavHeight(navbarEl.offsetHeight);

    const resizeObserver = new ResizeObserver(() => {
      if (navbarEl) setNavHeight(navbarEl.offsetHeight);
    });

    if (navbarEl) resizeObserver.observe(navbarEl);
    return () => resizeObserver.disconnect();
  }, []);

  return (
    <MDBox
      sx={(theme) => ({
        position: "sticky",
        top: `${navHeight - 1}px`,
        zIndex: 999,
        backgroundColor: "#ffffff",
        boxShadow: isTransparent ? "none" : "0 4px 12px rgba(0, 0, 0, 0.2)",
        padding: "16px",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        borderRadius: "8px",
        gap: 2,
        flexWrap: "wrap",
        transition: "top 0.3s ease, background-color 0.3s ease, box-shadow 0.3s ease",
      })}
    >
      <ChartCategorySelector
        selectedCategories={selectedCategories}
        setSelectedCategories={setSelectedCategories}
        selectedProfiles={selectedProfiles} // ✅ Pass Profiles
      />

      <MDBox sx={{ display: "flex", alignItems: "center", gap: 2 }}>
        {/* <ADDateRange onDateChange={onDateChange} /> */}
        <ADDateRange key={validationAttempt} onDateChange={onDateChange} value={dateRange} />
      </MDBox>

      {/* Tool Selector */}
      <ToolSelector
        chartIds={activeChartIds}
        selectedProfiles={selectedProfiles}
        dateRange={dateRange}
        isPredictionEnabled={isPredictionEnabled}
        contentChartRef={contentChartRef}
        onAddProfile={onAddProfile}
        entitlements={entitlements}
        chartViewModes={chartViewModes}
        onScheduleReport={onScheduleReport}
      />
    </MDBox>
  );
}

Toolbar.propTypes = {
  onDateChange: PropTypes.func.isRequired,
  onTogglePrediction: PropTypes.func.isRequired,
  isPredictionEnabled: PropTypes.bool.isRequired,
  selectedCategories: PropTypes.arrayOf(PropTypes.string).isRequired,
  setSelectedCategories: PropTypes.func.isRequired,
  selectedProfiles: PropTypes.array.isRequired,
  dateRange: PropTypes.array.isRequired,
  contentChartRef: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.shape({ current: PropTypes.object }),
  ]).isRequired,
  onAddProfile: PropTypes.func.isRequired,
  entitlements: PropTypes.object,
  validationAttempt: PropTypes.number,
  chartViewModes: PropTypes.object,
  onScheduleReport: PropTypes.func,
};

export default Toolbar;